import { COLOR } from '@ordermentum/ui-constants';
import {
  HEIGHT,
  SHADOW,
  PADDING,
  BORDER_RADIUS,
  FONT_SIZE,
  FONT_WEIGHT,
  BREAKPOINTS,
} from '@ordermentum/ui-static';

export const standard = {
  height: {
    large: '3.5rem',
    medium: '2rem',
    default: HEIGHT.INPUT,
  },
  tooltip: {
    bg: COLOR.BLACK,
    text: COLOR.WHITE,
  },
  error: {
    text: COLOR.RED_500,
  },
  border: {
    active: `1px solid ${COLOR.GRAY_400}`,
    inActive: `1px solid ${COLOR.GRAY_400}`,
    error: `1px solid ${COLOR.RED_500}`,
  },
  boxShadow: {
    active: SHADOW.INPUT,
    inActive: SHADOW.INPUT,
    error: `0 0 3px ${COLOR.RED_CC0000}`,
  },
  padding: `0 ${PADDING.INPUT_LR}`,
  borderRadius: BORDER_RADIUS.SMALL,
  color: {
    active: 'initial',
    inActive: 'initial',
    error: 'initial',
  },
  fontSize: FONT_SIZE.SMALL,
  fontWeight: FONT_WEIGHT.LIGHT,
  background: {
    active: COLOR.WHITE,
    inActive: COLOR.GRAY_300,
    error: COLOR.RED_200,
  },
  cursor: {
    active: 'default',
    inActive: 'not-allowed',
    readOnly: 'default',
    error: 'default',
  },
  width: {
    auto: 'auto',
    max: '100%',
    large: '17.5rem',
    medium: '12.5rem',
    small: '10rem',
    xs: '5rem',
    default: '12.5rem',
  },
  readOnly: {
    paddingLeft: '0',
  },
  labelColor: {
    active: 'initial',
    inActive: 'initial',
    error: 'initial',
  },
  hintColor: {
    active: 'initial',
    inActive: 'initial',
    error: 'initial',
  },
  errorLabelColor: {
    error: COLOR.RED_500,
  },
  extras: {
    [`@media (min-width: ${BREAKPOINTS.MOBILE_MAX})`]: {
      fontSize: FONT_SIZE.BASE,
    },
    [`&:focus`]: {
      outline: `${COLOR.GRAY_400} auto 5px`,
      outlineOffset: '-2px',
    },
    '&:disabled': {
      background: 'inherit',
      cursor: 'not-allowed',
      color: COLOR.GRAY_400,
      backgroundColor: COLOR.GRAY_100,
    },
  },
};
